import { render, staticRenderFns } from "./journalsOperate.vue?vue&type=template&id=3c8b45b1&scoped=true"
import script from "./journalsOperate.vue?vue&type=script&lang=js"
export * from "./journalsOperate.vue?vue&type=script&lang=js"
import style0 from "./journalsOperate.vue?vue&type=style&index=0&id=3c8b45b1&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c8b45b1",
  null
  
)

export default component.exports